import { i18n } from '@/plugins/i18n'

export const statuses = [
        {
            name: '',
            value: ''
        },
        {
            name: i18n.t('gateway_status.active'),
            value: 1
        },
        {
            name: i18n.t('gateway_status.pending'),
            value: 2
        },
        {
            name: i18n.t('gateway_status.rejected'),
            value: 3
        },
        {
            name: i18n.t('gateway_status.blocked'),
            value: 4
        },
        {
        name: i18n.t('gateway_status.archive'),
        value: 5
        },
        {
            name: i18n.t('gateway_status.send_to_shaparak'),
            value: 9
        },
        {
            name: i18n.t('gateway_status.rejected_by_shaparak'),
            value: 10
        },
        {
            name: i18n.t('gateway_status.direct_to_psp'),
            value: 11
        },
        {
            name: i18n.t('gateway_status.enamad_pending'),
            value: 12
        },
        {
            name: i18n.t('gateway_status.enamad_authenticated'),
            value: 13
        },
        {
            name: i18n.t('gateway_status.awaiting_contract'),
            value: 14
        },
    ];

export const gatewayStatus = {
    ACTIVE: 1,
    PENDING: 2,
    REJECTED: 3,
    BLOCKED: 4,
    ARCHIVE: 5,
    SEND_TO_SHAPARAK: 9,
    REJECTED_BY_SHAPARAK: 10,
    DIRECT_TO_PSP: 11,
    ENAMAD_PENDING: 12,
    ENAMAD_AUTHENTICATED: 13,
    AWAITING_CONTRACT: 14,
}

export const gatewayStatusStr = {
    ACTIVE: i18n.t('gateway_status.active'),
    PENDING: i18n.t('gateway_status.pending'),
    REJECTED: i18n.t('gateway_status.rejected'),
    BLOCKED: i18n.t('gateway_status.blocked'),
    ARCHIVE: i18n.t('gateway_status.archive'),
    REJECTED_BY_SHAPARAK: i18n.t('gateway_status.rejected_by_shaparak'),
    SEND_TO_SHAPARAK: i18n.t('gateway_status.send_to_shaparak'),
    DIRECT_TO_PSP: i18n.t('gateway_status.direct_to_psp'),
    ENAMAD_PENDING: i18n.t('gateway_status.enamad_pending'),
    ENAMAD_AUTHENTICATED: i18n.t('gateway_status.enamad_authenticated'),
    AWAITING_CONTRACT: i18n.t('gateway_status.awaiting_contract'),
    get(status) {
        let status_str = null;
        Object.keys(gatewayStatus).forEach(function (item) {
            if(gatewayStatus[item] === status) {
                status_str = gatewayStatusStr[item]
            }
        })

        return status_str
    }
}

export const gatewayVariant = (status) => {
    if(status === gatewayStatus.ACTIVE || status === gatewayStatus.HAS) {
        return 'success'
    }

    if(status === gatewayStatus.DOES_NOT_HAVE 
        || status === gatewayStatus.REJECTED
        || status === gatewayStatus.BLOCKED
        || status === gatewayStatus.REJECTED_BY_SHAPARAK
        || status === gatewayStatus.ARCHIVE
    ) {
        return 'danger'
    }

    if(status === gatewayStatus.PENDING
        || status === gatewayStatus.SEND_TO_SHAPARAK
        || status === gatewayStatus.ENAMAD_PENDING
        || status === gatewayStatus.AWAITING_CONTRACT
    ) {
        return 'warning'
    }

    if (status === gatewayStatus.DIRECT_TO_PSP) {
        return 'primary';
    }

    return 'info'
} 